import React, { useState } from "react";
import Dialog from "../../base/ui/components/web/Dialog";
import { translate } from "../../base/i18n/functions";
import { Box } from "@mui/material";

import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

import { useDispatch } from "react-redux";
import { openChat, sendSignatureMessage } from "../../chat/actions.web";
import { getParticipantById } from "../../base/participants/functions";
import Button from "../../base/ui/components/web/Button";
import { BUTTON_TYPES } from "../../base/ui/constants.any";

const PayDialog = ({ state, participantId, payUrl }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const participantObject = getParticipantById(state, participantId);
    const [copied, setCopied] = useState(false);

    const handleSubmit = () => {
        dispatch(openChat(participantObject));
        dispatch(
            sendSignatureMessage(participantId, t("dialog.admitPayService"))
        );
        window.open(payUrl?.current, "_blank");
    };

    const handleCopyUrl = () => {
        navigator.clipboard.writeText(payUrl?.current);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 5000);
    };

    const onClose = () => {
        dispatch(openChat(participantObject));
        dispatch(
            sendSignatureMessage(participantId, t("dialog.rejectPayService"))
        );
        return true;
    };
    const copyButton = (
        <Button
            aria-label={t("dialog.copyPaymentLink")}
            className={`invite-button ${copied ? "copied-button" : ""}`}
            label={
                copied
                    ? t("dialog.PaymentLinkcopied")
                    : t("dialog.copyPaymentLink")
            }
            onClick={handleCopyUrl}
            role="button"
            type={BUTTON_TYPES.PRIMARY}
        />
    );

    return (
        <Dialog
            ok={{ translationKey: "dialog.pay" }}
            cancel={{ hidden: true }}
            copy={{ hidden: false, copyButton: copyButton }}
            onCancel={onClose}
            onSubmit={handleSubmit}
            titleKey={t("dialog.payTitle", {
                participantName: participantObject.name,
            })}
        >
            <Box
                sx={{
                    display: "flex",
                    "& label": {
                        minWidth: "125px",
                        fontSize: "15px",
                        fontWeight: "bold",
                        flexDirection: "column",
                    },
                }}
            >
                <label style={{ marginBlockEnd: "10px" }}>Payment Link: </label>
                <div style={{ overflowWrap: "anywhere" }}>
                    {payUrl?.current}
                </div>
            </Box>
        </Dialog>
    );
};

export function _mapStateToProps(state) {
    return {
        state: state,
    };
}

export default translate(connect(_mapStateToProps)(PayDialog));
